<script lang="ts">
  import { Button } from "$lib/components/ui/button/index.js";

  type TablePaginationProps = {
    pageSizeOptions?: number[];
    pageSize?: number;
    page?: number;
    totalPages?: number;
    canGoPrevious?: boolean;
    canGoNext?: boolean;
    isLoading?: boolean;
    onPageSizeChange?: (value: number) => void;
    onPrevious?: () => void;
    onNext?: () => void;
  };

  let {
    pageSizeOptions = [],
    pageSize = 15,
    page = 1,
    totalPages = 1,
    canGoPrevious = false,
    canGoNext = false,
    isLoading = false,
    onPageSizeChange = (_value: number) => {},
    onPrevious = () => {},
    onNext = () => {}
  }: TablePaginationProps = $props();

  const handlePageSizeChange = (event: Event) => {
    const target = event.currentTarget as HTMLSelectElement;
    onPageSizeChange(Number(target.value));
  };

  const handlePreviousClick = () => {
    onPrevious();
  };

  const handleNextClick = () => {
    onNext();
  };
</script>

<div class="flex flex-wrap items-center justify-between gap-2">
  <div class="flex items-center gap-2">
    <label for="table-page-size" class="text-sm text-muted-foreground">Rows per page</label>
    <select
      id="table-page-size"
      class="h-9 rounded-md border border-input bg-background px-3 text-sm"
      onchange={handlePageSizeChange}
    >
      {#each pageSizeOptions as option}
        <option value={option} selected={option === pageSize}>{option}</option>
      {/each}
    </select>
  </div>

  <div class="flex items-center gap-2">
    <Button type="button" variant="outline" onclick={handlePreviousClick} disabled={!canGoPrevious || isLoading}>
      Previous
    </Button>
    <span class="text-sm text-muted-foreground">Page {page} of {totalPages}</span>
    <Button type="button" variant="outline" onclick={handleNextClick} disabled={!canGoNext || isLoading}>
      Next
    </Button>
  </div>
</div>
